import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAdminAuth } from '../../lib/adminAuth'
import { hasRole } from '../../lib/roles'

// Generic admin-role guard for staff surfaces. Default required role is
// 'support' so the existing support console route keeps working; pass `role`
// for higher privileges. This guard reads the DEDICATED admin-console session
// (`useAdminAuth`), kept fully independent from the end-user session.
export default function AdminGuard({ children, role = 'support' }) {
  const { adminUser, adminRole, initializing } = useAdminAuth()
  const location = useLocation()

  if (initializing) {
    return (
      <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ textAlign: 'center', color: 'var(--text-secondary)' }}>Loading.</div>
      </div>
    )
  }

  if (!adminUser) {
    return <Navigate to="/login/admin" replace state={{ from: location.pathname + location.search }} />
  }

  if (!hasRole({ app_metadata: { role: adminRole } }, role)) {
    // Admin surfaces redirect to the support console; support surfaces redirect
    // to /support. User and staff surfaces are intentionally kept separate.
    return <Navigate to="/support" replace />
  }

  return children
}